import type { ILayerProps, ISlide } from '@/version-types';
import { renderLayerToStage } from './render-to-stage';

export const renderLayerToPPT = async (
    slide: ISlide,
    layer: ILayerProps,
    stageWidth: number,
    stageHeight: number,
    identity: string,
    watermark?: HTMLCanvasElement,
) => {
    const canvas = await renderLayerToStage(layer, { width: stageWidth, height: stageHeight }, identity);
    if (watermark) {
        const ctx = canvas?.getContext('2d');
        ctx?.drawImage(
            watermark,
            0,
            0,
            watermark.width,
            watermark.height,
            layer.left + layer.width - 50 - watermark.width,
            layer.top + layer.height - 50 - watermark.height,
            watermark.width,
            watermark.height,
        );
    }
    slide.background = { data: canvas?.toDataURL() };
};
